import styles from "./styles.scss";
import { Body, Heading } from "../typography";
import ListItem from "../list-item";
import Avatar from "../avatar";
import { useContext, useState } from "preact/hooks";
import { CurrentUserContext, OrganizationContext } from "../../contexts";
import Icon from "../Icon/Icon";
import {NavigationContext} from "../../contexts/NavigationContext";

function orderByName(a, b) {
  if ( a.name < b.name ){
    return -1;
  }
  if ( a.name > b.name ){
    return 1;
  }
  return 0;
}

export default function ContactList() {
  let { loading, profiles } = useContext(OrganizationContext);
  const { internalId } = useContext(CurrentUserContext);
  const { navigate } = useContext(NavigationContext);

  const [isCreatingBroadcast, setCreatingBroadcast] = useState(false);
  const [users, setUsers] = useState([]);

  const onRequestChat = contactInternalId => {
    navigate({ path: "/chat", params: { contactInternalId, room: '' } });
  };

  const onRequestBroadcast = broadcastList => {
    navigate({ path: "/chat", params: { broadcastList }});
  };

  // noinspection JSUnresolvedVariable
  profiles = profiles
    ? profiles.filter(p => p.internal_id !== internalId).sort(orderByName)
    : null;

  return (
    <div className={styles.container}>
      {!isCreatingBroadcast && <ListItem
        title="Nova lista de transmissão"
        subtitle="Envie mensagens em massa para os contatos da empresa (beta)"
        hoverFeedback
        fadedSubtitle
        right={<Icon name="arrow_forward" />}
        onClick={() => setCreatingBroadcast(true)}
      />}
      {isCreatingBroadcast && <ListItem
        title="Criar lista de transmissão"
        subtitle={"Usuários: " + users.map(p => p.name).join(", ")}
        hoverFeedback
        fadedSubtitle
        right={<Icon name="arrow_forward" />}
        onClick={() => onRequestBroadcast(users)}
      />}
      {!loading && profiles.length === 0 && (
        <div>
          <Body style={{ textAlign: "center" }}>
            Você não possui nenhum contato.
          </Body>
        </div>
      )}

      {!loading && (
        <div className={styles.listContainer}>
          {profiles.map(profile => (
            <ListItem
              key={profile.id}
              left={<Avatar src={profile.avatar_url} />}
              title={<Heading>{profile.name}</Heading>}
              subtitle={<Body>{profile.bio}</Body>}
              right={isCreatingBroadcast && users.includes(profile) && <Icon name="check" />}
              onClick={() => {
                isCreatingBroadcast ? (users.includes(profile) ? setUsers(users.filter(p => p !== profile)) : setUsers([...users, profile])) : onRequestChat(profile.internal_id)
              }}
              hoverFeedback
              fadedSubtitle
            />
          ))}
        </div>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./components/contact-list/index.js